import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { FaRegTrashCan } from "react-icons/fa6";
import Swal from "sweetalert2";
import "./valeCooler.css";

function CoolerExpoView({ awb, operacion, onBack }) {
  // Temperatura requerida mostrada en UI (por defecto "N/A")
  const [temperaturaRequerida, setTemperaturaRequerida] =
    useState("Sin registro");

  // Campos controlados del formulario
  const [movimiento, setMovimiento] = useState(""); // select Movimiento
  const [temperatura, setTemperatura] = useState(""); // input temperatura (número)
  const [searchIngreso, setSearchIngreso] = useState(""); // texto buscador
  const [selectedIngreso, setSelectedIngreso] = useState(""); // valor seleccionado para "Realiza Ingreso"
  const [showIngresoList, setShowIngresoList] = useState(false);
  const [observaciones, setObservaciones] = useState("");
  const [locacion, setLocacion] = useState("");
  const [fechaActual, setFechaActual] = useState("");
  const [horaActual, setHoraActual] = useState("");

  // Controlar visibilidad de tabla piezas
  const [showTablaPiezas, setShowTablaPiezas] = useState(false);

  // Tabla dinámicas PIEZAS
  const [piezasRows, setPiezasRows] = useState([
    {
      piezas: "",
      peso: "",
      locacion: "",
      pallet: "",
      showLoc: false,
      showPallet: false,
    }, // FILA FIJA
  ]);

  // Histórico local (array de filas)
  const [historicoRows, setHistoricoRows] = useState([]);

  // Referencia para detectar click fuera del buscador
  const ingresoRef = useRef(null);

  useEffect(() => {
    const now = new Date();

    const fecha = now.toISOString().split("T")[0];
    const hora = now.toTimeString().split(" ")[0].slice(0, 5);

    setFechaActual(fecha);
    setHoraActual(hora);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ingresoRef.current && !ingresoRef.current.contains(event.target)) {
        setShowIngresoList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Cerrar selects Locación y Pallet al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      setPiezasRows((prev) =>
        prev.map((row) => ({
          ...row,
          showLoc: false,
          showPallet: false,
        }))
      );
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const locacionOptions = [
    { value: "TAL", label: "Talma" },
    { value: "TME", label: "TME" },
    { value: "AAA", label: "AAACESA" },
    { value: "WEC", label: "WEC" },
    { value: "IMM", label: "IMM" },
  ];

  // Opciones del buscador (ejemplo)
  const ingresoOptions = [
    "204005, ADRIAN MORENO VALADEZ",
    "184118, AGUSTIN MATÍAS RAMOS",
    "201478, ALEJANDRO VELAZQUEZ GONZALEZ",
    "12232, Alicia Paredes Perez",
    "408017, ANGEL RODRIGO LOPEZ VAZQUEZ",
    "215517, CARLOS GARCIA TORRES",
    "44923, CRISTHIAN ANTONIO CHAVEZ LUNA",
  ];

  const filteredOptions = ingresoOptions.filter((opt) =>
    opt.toLowerCase().includes(searchIngreso.toLowerCase())
  );

  const toggleHistoricoCheck = (index) => {
    setHistoricoRows((prev) =>
      prev.map((row, i) => (i === index ? { ...row, check: !row.check } : row))
    );
  };

  // Maneja la edición de Temperatura requerida vía SweetAlert (igual que antes)
  const temperatureAlert = () => {
    Swal.fire({
      title: "",
      html: `
        <div class="container-fluid text-left">
          <div class="row">
            <div class="col-md-6 d-flex justify-content-center align-items-center mt-3">
              <h3 class="fw-bold text-center m-0" style="font-size: 15px;">Temperatura requerida</h3>
            </div>

            <div class="col-md-6 mt-3">
              <select id="temperatura_select" class="form-select" style="border-radius:8px;">
                <option value="" disabled selected>Selecciona temperatura</option>
                <option>N/A</option>
                <option value="FRO: -7°C a -2°C">FRO: -7°C a -2°C</option>
                <option value="COL: +2°C a +8°C">COL: +2°C a +8°C</option>
                <option value="ERT: +2°C a +25°C">ERT: +2°C a +25°C</option>
                <option value="CRT: +15°C a +25°C">CRT: +15°C a +25°C</option>
              </select>
            </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Guardar",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        popup: "alert-bg",
      },
      preConfirm: () => {
        const value = document.getElementById("temperatura_select").value;
        if (!value) {
          Swal.showValidationMessage("Debes seleccionar una opción");
        }
        return value;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setTemperaturaRequerida(result.value);
        // Si la temperatura cambia, permitir que aparezca "Ingreso" en el select Movimiento:
        // (esto lo manejamos dinámicamente al construir las opciones del select)

        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Nueva temperatura actualizada con éxito.`,
          confirmButtonText: "OK",
          customClass: { confirmButton: "btn-ok" },
        });
      }
    });
  };

  // Resetea los campos editables (se usan cuando el usuario intenta guardar)
  const resetEditableFields = () => {
    setMovimiento("");
    setTemperatura("");
    setSelectedIngreso("");
    setSearchIngreso("");
    setShowIngresoList(false);
    setObservaciones("");
  };

  // Handler del botón Guardar (no guarda nada en backend)
  const handleGuardar = (e) => {
    e.preventDefault();

    const anyFilled =
      movimiento &&
      movimiento.trim() !== "" &&
      temperatura !== "" &&
      selectedIngreso &&
      selectedIngreso.trim() !== "";

    // const anyFilled =
    //   movimiento && movimiento.trim() !== "" &&
    //   temperatura !== "" &&
    //   temperatura !== null &&
    //   selectedIngreso &&
    //   selectedIngreso.trim() !== "";

    if (!anyFilled) {
      Swal.fire({
        icon: "info",
        title: "Campos incompletos",
        text: "Debes llenar todos los campos para continuar.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn-ok" },
      });
      return;
    }

    // 👉 CASO 1: Transferencia o Resguardo -> SE GUARDA EN HISTÓRICO
    if (movimiento === "Transferencia" || movimiento === "Resguardo") {
      const now = new Date();
      const fecha = now.toISOString().split("T")[0];
      const hora = now.toTimeString().split(" ")[0].slice(0, 5);

      const newRow = {
        movimiento,
        temperatura: temperatura,
        piezas: "-",
        peso: "-",
        fecha,
        hora,
        observaciones: observaciones || "-",
        check: false,
      };

      setHistoricoRows((prev) => [newRow, ...prev]);

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Registro agregado al histórico correctamente.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn-ok" },
      }).then(() => {
        resetEditableFields();
      });

      return;
    }

    // 👉 CASO 2: Ingreso / Reingreso -> NO GUARDA, SOLO MUESTRA ALERTA
    if (movimiento === "Ingreso" || movimiento === "Reingreso") {
      setShowTablaPiezas(true);

      Swal.fire({
        icon: "warning",
        title: "Proceso detenido",
        text: "Para realizar este proceso, es necesario el 'Inicio Despaletizado'",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn-ok" },
      }).then(() => {
        resetEditableFields();
        setShowTablaPiezas(true); // se mantiene visible
      });

      return;
    }
  };

  // Opciones completas cuando SÍ hay temperatura registrada
  const movConTemperatura = [
    "Camión",
    "Ingreso",
    "Reingreso",
    "Transferencia",
    "Resguardo",
  ];

  // Opciones cuando la temperatura requerida está SIN REGISTRO
  const movimientoOptions =
    temperaturaRequerida === "Sin registro"
      ? ["Camión"] // SOLO esta opción
      : movConTemperatura;

  // Mostrar/Ocultar Locación:
  // - Por defecto oculto (cuando movimiento === ""), se muestra si movimiento !== "" y movimiento !== "Anden/Confronta"
  const showLocacion =
    movimiento !== "" &&
    movimiento !== "Anden/Confronta" &&
    movimiento !== "Ingreso" &&
    movimiento !== "Reingreso";

  // Mostrar div rojo: cuando movimiento es Ingreso o Reingreso
  const showDivRojo = movimiento === "Ingreso" || movimiento === "Reingreso";

  const updateRow = (index, field, value) => {
    setPiezasRows((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addRow = () => {
    setPiezasRows((prev) => [
      ...prev,
      {
        piezas: "",
        peso: "",
        locacion: "",
        pallet: "",
        showLoc: false,
        showPallet: false,
      },
    ]);
  };

  const removeRow = (index) => {
    setPiezasRows((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <Helmet>
        <title>Horus | Vale Cooler</title>
      </Helmet>

      <ScrollToTop />

      <div className="container-fluid">
        {/* ------------ DATOS GENERALES ------------ */}
        <div className="row">
          <div className="col-md-12 mb-3 text-right">
            <div className="col-12 d-flex justify-content-end">
              <button className="btnn">Tiempos expo</button>
            </div>
          </div>

          <div className="col-md-3">
            <strong className="bold">Master: </strong>123-55557777
          </div>
          <div className="col-md-3">
            <strong className="bold">Piezas: </strong>100
          </div>
          <div className="col-md-3">
            <strong className="bold">Peso: </strong>100
          </div>
          <div className="col-md-3">
            <strong className="bold">Volumen: </strong>100
          </div>

          <div className="col-md-3 mt-4">
            <strong className="bold">Origen: </strong>MAD
          </div>
          <div className="col-md-3 mt-4">
            <strong className="bold">Destino: </strong>MEX
          </div>
          <div className="col-md-3 mt-4">
            <strong className="bold">Tipo de mercancía: </strong>Perecedero
          </div>

          {/* --- Temperatura requerida editada dinámicamente --- */}
          <div className="col-md-3 mt-4">
            <strong className="bold">Temperatura requerida: </strong>
            <span>{temperaturaRequerida}</span>

            <div className="mt-2">
              <button className="btn-pink-secondary" onClick={temperatureAlert}>
                Editar
              </button>
            </div>
          </div>
        </div>

        {/* --- FORMULARIO --- */}
        <form onSubmit={handleGuardar}>
          <div className="row mt-4">
            {/* Movimiento */}
            <div className="col-md-3">
              <label className="micro-title font-semibold mb-2">
                Movimiento
              </label>
              <select
                className="form-select"
                value={movimiento}
                onChange={(e) => {
                  setMovimiento(e.target.value);
                  // Si selecciona Ingreso/Reingreso vamos a mostrar tabla piezas
                  if (
                    e.target.value === "Ingreso" ||
                    e.target.value === "Reingreso"
                  ) {
                    setShowTablaPiezas(true);
                  } else {
                    setShowTablaPiezas(false);
                  }
                }}
              >
                <option value="" disabled>
                  Selecciona una opción
                </option>
                {movimientoOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            {/* Temperatura */}
            <div className="col-md-3">
              <label className="micro-title font-semibold mb-2">
                Temperatura
              </label>
              <input
                type="number"
                className="form-control"
                value={temperatura}
                step="any"
                placeholder=""
                onKeyDown={(e) => {
                  // permitir: borrar, tab, enter, flechas, punto, guion
                  const allowed = [
                    "Backspace",
                    "Tab",
                    "Enter",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowUp",
                    "ArrowDown",
                    "Delete",
                    ".",
                    "-",
                  ];

                  // si la tecla es permitida → OK
                  if (allowed.includes(e.key)) return;

                  // bloquear letras
                  if (e.key.match(/[a-zA-Z]/)) {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(e) => setTemperatura(e.target.value)}
              />
            </div>

            {/* --- SELECT CON BUSCADOR --- */}
            <div
              className="col-md-3"
              ref={ingresoRef}
              style={{ position: "relative" }}
            >
              <label className="micro-title font-semibold mb-2">
                Realiza Ingreso
              </label>

              {/* Input + ícono ▼ */}
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Selecciona una opción…"
                  value={selectedIngreso || searchIngreso}
                  onChange={(e) => {
                    setSelectedIngreso("");
                    setSearchIngreso(e.target.value);
                    setShowIngresoList(true);
                  }}
                  onFocus={() => setShowIngresoList(true)}
                  style={{ paddingRight: "30px" }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    fontSize: "12px",
                    color: "#555",
                    cursor: "pointer", // icono muestra manita
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Lista de opciones */}
              {showIngresoList && (
                <div
                  className="mt-1"
                  role="listbox"
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    background: "white",
                    position: "absolute",
                    zIndex: 20,
                    width: "92%",
                    borderRadius: "6px",
                    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                    border: "1px solid #ddd",
                  }}
                >
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((opt) => (
                      <div
                        key={opt}
                        onClick={() => {
                          setSelectedIngreso(opt);
                          setSearchIngreso("");
                          setShowIngresoList(false);
                        }}
                        style={{
                          padding: "10px 12px",
                          cursor: "pointer", // <-- manita al acercar el cursor
                          borderBottom: "1px solid #f1f1f1",
                        }}
                        tabIndex={0}
                      >
                        {opt}
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: "10px 12px", color: "#777" }}>
                      No hay resultados
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Observaciones */}
            <div className="col-md-3">
              <label className="micro-title font-semibold mb-2">
                Observaciones
              </label>
              <textarea
                className="form-control"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </div>

            {/* --- CAMPOS NO EDITABLES --- */}
            <div className="col-md-3 mt-3">
              <label className="micro-title font-semibold mb-2">
                Responsable
              </label>
              <input
                type="text"
                readOnly
                className="form-control"
                style={{ background: "#E3E3E3" }}
                value="Ezequiel Bernal"
              />
            </div>

            <div className="col-md-3 mt-3">
              <label className="micro-title font-semibold mb-2">Fecha</label>
              <input
                type="date"
                readOnly
                className="form-control"
                style={{ background: "#E3E3E3" }}
                value={fechaActual}
              />
            </div>

            <div className="col-md-3 mt-3">
              <label className="micro-title font-semibold mb-2">Hora</label>
              <input
                type="time"
                readOnly
                className="form-control"
                style={{ background: "#E3E3E3" }}
                value={horaActual}
              />
            </div>

            {/* LOCACIÓN (por defecto oculto) */}
            {showLocacion && (
              <div className="col-md-3 mt-3">
                <label className="micro-title font-semibold mb-2">
                  Locación
                </label>
                <select
                  className="form-select"
                  value={locacion}
                  onChange={(e) => setLocacion(e.target.value)}
                >
                  <option value="">Selecciona una opción</option>
                  {locacionOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* --- DIV ROJO (aparece solo para Ingreso/Reingreso) */}
          {showDivRojo && (
            <div className="row col-md-6 mt-4 row_flex">
              {/* COLUMNA IZQUIERDA */}
              <div className="col-md-6 mt-4">
                <label className="bold">En la cámara hay presencia de:</label>
                <p className="mt-2 mb-3">Compatibilidad</p>

                <p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="perCheck"
                    />
                    <label className="form-check-label" htmlFor="perCheck">
                      PER
                    </label>
                  </div>
                </p>

                <p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="pilCheck"
                    />
                    <label className="form-check-label" htmlFor="pilCheck">
                      PIL
                    </label>
                  </div>
                </p>

                <p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="dgCheck"
                    />
                    <label className="form-check-label" htmlFor="dgCheck">
                      DG
                    </label>
                  </div>
                </p>
              </div>

              {/* COLUMNA DERECHA */}
              <div className="col-md-6 mt-4">
                <label className="bolder">Se encuentra limpia la cámara:</label>
                <p className="mt-2 mb-3">Limpieza (Pharma)</p>

                <p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="limpieza"
                      id="siCheck"
                    />
                    <label className="form-check-label" htmlFor="siCheck">
                      Si
                    </label>
                  </div>
                </p>

                <p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="limpieza"
                      id="noCheck"
                    />
                    <label className="form-check-label" htmlFor="noCheck">
                      No
                    </label>
                  </div>
                </p>
              </div>
            </div>
          )}

          {/* --- TABLA PIEZAS DINÄMICA (se muestra cuando movimiento es Ingreso/Reingreso) */}
          {showTablaPiezas && (
            <div className="row mt-4 justify-content-center">
              <div className="col-md-8">
                <table className="table text-center fondo-head">
                  <thead>
                    <tr>
                      <th>Piezas</th>
                      <th>Peso</th>
                      <th>Locación</th>
                      <th>Pallet</th>
                      <th>Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Como no tienes inputs de piezas/peso todavía, dejo una fila de ejemplo vacía */}
                    {piezasRows.map((row, index) => (
                      <tr key={index}>
                        {/* PIEZAS */}
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={row.piezas}
                            onChange={(e) =>
                              updateRow(index, "piezas", e.target.value)
                            }
                          />
                        </td>
                        {/* PESO */}
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={row.peso}
                            onChange={(e) =>
                              updateRow(index, "peso", e.target.value)
                            }
                          />
                        </td>
                        {/* LOCACIÓN CON BUSCADOR */}
                        <td style={{ position: "relative" }}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar locación…"
                            value={row.locacion}
                            onChange={(e) =>
                              updateRow(index, "locacion", e.target.value)
                            }
                            onFocus={() => {
                              updateRow(index, "showLoc", true);
                              updateRow(index, "showPallet", false); // cerrar pallet
                            }}
                            style={{ paddingRight: "30px" }}
                          />

                          {/* Icono ▼ */}
                          <span
                            style={{
                              position: "absolute",
                              right: "13px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              fontSize: "12px",
                            }}
                          >
                            ▼
                          </span>

                          {/* Lista */}
                          {row.showLoc && (
                            <div
                              style={{
                                maxHeight: "150px",
                                overflowY: "auto",
                                background: "white",
                                position: "absolute",
                                zIndex: 20,
                                width: "100%",
                                borderRadius: "6px",
                                boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                              }}
                            >
                              {["Talma", "TME", "AAACESA", "WEC", "IMM"]
                                .filter((opt) =>
                                  opt
                                    .toLowerCase()
                                    .includes(row.locacion.toLowerCase())
                                )
                                .map((opt) => (
                                  <div
                                    key={opt}
                                    onClick={() => {
                                      updateRow(index, "locacion", opt);
                                      updateRow(index, "showLoc", false);
                                      updateRow(index, "showPallet", false);
                                    }}
                                    style={{
                                      padding: "10px 12px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {opt}
                                  </div>
                                ))}
                            </div>
                          )}
                        </td>
                        {/* PALLET CON BUSCADOR */}
                        <td style={{ position: "relative" }}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar pallet…"
                            value={row.pallet}
                            onChange={(e) =>
                              updateRow(index, "pallet", e.target.value)
                            }
                            onFocus={() => {
                              updateRow(index, "showPallet", true);
                              updateRow(index, "showLoc", false); // cerrar locación
                            }}
                            style={{ paddingRight: "30px" }}
                          />

                          {/* Icono ▼ */}
                          <span
                            style={{
                              position: "absolute",
                              right: "13px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              fontSize: "12px",
                              color: "#555",
                            }}
                          >
                            ▼
                          </span>

                          {/* Lista */}
                          {row.showPallet && (
                            <div
                              style={{
                                maxHeight: "150px",
                                overflowY: "auto",
                                background: "white",
                                position: "absolute",
                                zIndex: 20,
                                width: "100%",
                                borderRadius: "6px",
                                boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                              }}
                            >
                              {["Pallet 1", "Pallet 2", "Pallet 3"]
                                .filter((opt) =>
                                  opt
                                    .toLowerCase()
                                    .includes(row.pallet.toLowerCase())
                                )
                                .map((opt) => (
                                  <div
                                    key={opt}
                                    onClick={() => {
                                      updateRow(index, "pallet", opt);
                                      updateRow(index, "showPallet", false);
                                      updateRow(index, "showLoc", false);
                                    }}
                                    style={{
                                      padding: "10px 12px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {opt}
                                  </div>
                                ))}
                            </div>
                          )}
                        </td>
                        <td>
                          {index === 0 ? (
                            "" // No puede eliminarse
                          ) : (
                            <FaRegTrashCan
                              size={20}
                              color="red"
                              style={{ cursor: "pointer" }}
                              onClick={() => removeRow(index)}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="text-center mt-3">
                  <button
                    type="button"
                    className="btn btn-success px-4"
                    onClick={addRow}
                    style={{ fontSize: "22px", fontWeight: "bold" }}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="col-12 d-flex justify-content-end mt-3">
            <button type="submit" className="btnn">
              Guardar
            </button>
          </div>
        </form>

        {/* ---TABLA HISTÓRICO --- (SE MUESTRA SIEMPRE) */}
        <div className="row mt-4 justify-content-center">
          <div className="col-12">
            <h4 className="text-center mb-4">Histórico</h4>
          </div>

          <div className="col-md-8">
            <table className="table text-center fondo-head">
              <thead>
                <tr>
                  <th>Movimiento</th>
                  <th>Temperatura</th>
                  <th>Piezas</th>
                  <th>Peso</th>
                  <th>Fecha</th>
                  <th>Hora</th>
                  <th>Observaciones</th>
                  <th>Check</th>
                </tr>
              </thead>
              <tbody>
                {historicoRows.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No hay registros</td>
                  </tr>
                ) : (
                  historicoRows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.movimiento}</td>
                      <td>{row.temperatura}</td>
                      <td>{row.piezas}</td>
                      <td>{row.peso}</td>
                      <td>{row.fecha}</td>
                      <td>{row.hora}</td>
                      <td>{row.observaciones}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.check}
                          onChange={() => toggleHistoricoCheck(idx)}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="col-md-8 d-flex justify-content-end">
            <button className="btnn">Imprimir</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoolerExpoView;
